export const getDOBWithTime = (age) => {
  const dateString = new Date(new Date().setFullYear(new Date().getFullYear() - age))
    .toISOString()
    .split('T')[0]
  return `${dateString} 00:00:00`
}

export const getAgeFromDobWithTime = (dob) => {
  if (!dob) return ''

  const today = new Date()
  const birthDate = new Date(dob.substring(0, 10))
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDelta = today.getMonth() - birthDate.getMonth()
  if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}
